export default {
  localhost: 'https://api-site-blk.azurewebsites.net/api',
  homolog: 'https://api-site-blk.azurewebsites.net/api',
  development: 'https://blk.mblabs.site/api',
  production: 'https://api-site-blk.azurewebsites.net/api',
  token: "JPWBHoSh246yRLt8wdiYWYjSQKlpa3ChSaxoSbrAcgGLAzFuVnE6ug=="
};
